import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PulseCommentsComponent } from './pulse-comments.component';
import {AppPaginationModule} from "../pagination/pagination.module";


@NgModule({
  declarations: [PulseCommentsComponent],
  imports: [
    CommonModule,
    AppPaginationModule
  ],
  exports: [PulseCommentsComponent],
})
export class PulseCommentsComponentModule { }
